import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "./ui/alert-dialog";

export default function ConfirmDialog({
  open,
  onOpenChange,
  title = "Are you sure?",
  description = "This action can't be undone.",
  confirmLabel = "Delete",
  cancelLabel = "Cancel",
  onConfirm,
  destructive = true,
  testid = "confirm-dialog",
}) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent data-testid={testid} className="max-w-sm rounded-2xl">
        <AlertDialogHeader>
          <AlertDialogTitle className="font-display text-2xl tracking-tight">{title}</AlertDialogTitle>
          <AlertDialogDescription className="text-zinc-600">{description}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="gap-2">
          <AlertDialogCancel
            data-testid={`${testid}-cancel`}
            className="h-12 px-5 rounded-lg font-bold bg-white border border-zinc-200 text-zinc-900 hover:bg-zinc-50"
          >
            {cancelLabel}
          </AlertDialogCancel>
          <AlertDialogAction
            data-testid={`${testid}-confirm`}
            onClick={onConfirm}
            className={
              destructive
                ? "h-12 px-5 rounded-lg font-bold bg-red-600 text-white hover:bg-red-700"
                : "h-12 px-5 rounded-lg font-bold bg-zinc-950 text-white hover:bg-zinc-800"
            }
          >
            {confirmLabel}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
